





































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { InspectionFormSection } from '@/models/admin/inspection.form';
import { Base } from '@/components/common/base';
import { FileHelper } from '@/helper/file.helper';
import { ReviveInspection } from '@/models/inventory/vehiclerevivestep';
import { VHeaders } from '@/models/pagedlistmodel';
import { IDialogOption } from '@/models/dialog';
import {
  getquestionHeaders,
  getSectionHeaders,
} from '@/views/admin/inspectionforms/inspectionForms';
import { inspectionFormService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class AddInspectionFormPage extends Base {
  public sectionHeaders: VHeaders[] = getSectionHeaders(this);
  public questionHeaders: VHeaders[] = getquestionHeaders(this);
  public form: any = {};
  public inspectionFormFields: Array<VFields<any>> = [];
  public disableSubmitButton: boolean = false;
  public positions = [
    {
      text: this.$parent.$t('inspectionForms.positions.left') as string,
      value: 1,
    },
    {
      text: this.$parent.$t('inspectionForms.positions.right') as string,
      value: 2,
    },
  ];
  public inspectionForm: ReviveInspection = {
    name: '',
    numColumn: 2,
    sectionJson: [],
  };
  public inspectionSection: InspectionFormSection = {
    name: '',
    columnPosition: 1,
    questions: [],
  };
  public inspectionQuestion = {
    sectionName: '',
    text: '',
  };
  public sectionActions: any[] = [
    {
      type: 'button',
      icon: 'fas fa-edit',
      title: this.$parent.$t(
        'inspectionForms.addSectionGridHeaders.gridAction.editSection'
      ) as string,
      color: 'primary',
      visible: (model: any) => true,
      action: (model: any) => {
        this.editSection(model);
      },
    },
    {
      type: 'button',
      icon: 'fas fa-trash-alt',
      title: this.$parent.$t(
        'inspectionForms.addSectionGridHeaders.gridAction.deleteSection'
      ) as string,
      color: 'error',
      visible: (model: any) => true,
      action: (model: any) => {
        this.confirmDeleteSection(model);
      },
    },
  ];

  public questionActions: any[] = [
    {
      type: 'button',
      icon: 'fas fa-trash-alt',
      title: this.$parent.$t(
        'inspectionForms.addQuestionGridHeaders.gridAction.delete'
      ) as string,
      color: 'error',
      visible: (model: any) => true,
      action: (model: any) => {
        this.confirmDeleteQuestionFromSection(model);
      },
    },
  ];

  public onlyNameHeaders = [
    {
      text: this.$parent.$t(
        'inspectionForms.reviewSectionAndQuestionGridHeaders.question'
      ) as string,
      align: 'left',
      sortable: true,
      value: 'text',
    },
  ];
  public stepperIndex: number = 1;
  public storeId: number = 0;
  public type: string = '';
  public editSectionIndex = -1;
  public isSectionEditMode = false;
  public sectionNameToDelete = '';
  public questionToDelete = '';
  public isButtonLoading: boolean = false;

  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('inspectionForms.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    onAction: (): void => {
      this.deleteSection();
    },
  };
  public deleteQuestionDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$parent.$t(
      'inspectionForms.deleteDialogTitle'
    ) as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    onAction: (): void => {
      this.deletedQuestionFromSection();
    },
  };

  public created() {
    this.inspectionFormFields = [
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 150,
          label: this.$parent.$t(
            'inspectionForms.inspectionFormDetailsFields.inspectionFromName'
          ) as string,
          validations: `${ValidationRules.required}`,
          required: true,
          disabled: false,
          loading: false,
        },
      },
      {
        key: 'numColumn',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: this.$parent.$t(
            'inspectionForms.inspectionFormDetailsFields.numberOfColumns'
          ) as string,
          validations: `${ValidationRules.required}`,
          disabled: false,
          items: [{ column: 1 }, { column: 2 }],
          text: 'column',
          value: 'column',
          altag: 'Number Of Columns',
          loading: false,
        },
      },
    ];
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.inspection.forms.list',
        params: {
          storeId: this.storeId.toString(),
          type: this.type.toString(),
        },
      });
    } else if (methodName === 'cancel') {
      this.$router.push({
        name: 'admin.inspection.forms.list',
        params: {
          storeId: this.storeId.toString(),
          type: this.type.toString(),
        },
      });
    } else if (
      methodName === 'stepperIndexTwo' ||
      methodName === 'backToSection'
    ) {
      if (!this.inspectionForm.name) {
        this.showAlert(
          false,
          this.$parent.$t('inspectionForms.alertInspectionFormNameRequired')
        );
        this.resetMethodName(methodName);
        return;
      }
      this.stepperIndex = 2;
      this.addSectionButtons();
    } else if (
      methodName === 'backToDetail' ||
      methodName === 'backToInspectionForm'
    ) {
      this.stepperIndex = 1;
      this.inspectionFormDetailsButtons();
    } else if (
      methodName === 'continueToAddQuestions' ||
      methodName === 'backToQuestions'
    ) {
      if (
        !(this.inspectionForm.sectionJson.length > 0) ||
        this.isSectionEditMode
      ) {
        this.showAlert(
          false,
          this.$parent.$t('inspectionForms.alertSectionRequired')
        );
        this.resetMethodName(methodName);
        return;
      }
      this.switchToQuestionTab();
      this.addQuestionsButtons();
    } else if (
      methodName === 'continueToReview' ||
      methodName === 'backToReview'
    ) {
      if (!(this.inspectionSection.questions.length > 0)) {
        this.showAlert(
          false,
          this.$parent.$t('inspectionForms.alertQuestionRequired')
        );
        this.resetMethodName(methodName);
        return;
      }
      this.stepperIndex = 4;
      this.addReviewSectionAndQuestionsButtons();
    } else if (methodName === 'continueToSubmit') {
      this.stepperIndex = 5;
      this.addSubmitInspectionFormButtons();
    } else if (methodName === 'previewInspectionPDF') {
      this.downloadInspectionPreview();
    } else if (methodName === 'submit') {
      this.submitInspectionForm();
    }

    this.resetMethodName(methodName);
  }

  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public inspectionFormDetailsButtons(): void {
    const buttons: any = [];
    buttons.push({
      id: '1',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnContinueToAddSections'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('inspectionForms.btnContinueToAddSections'),
      click: 'stepperIndexTwo',
      icon: 'fas fa-angle-right',
    });
    this.updateToolBar(buttons);
  }
  public addSectionButtons(): void {
    const buttons: any = [];
    buttons.push({
      id: '1',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('inspectionForms.btnBack'),
      click: 'backToDetail',
      icon: 'fas fa-angle-left',
    });
    buttons.push({
      id: '2',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnContinueToAddQuestions'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('inspectionForms.btnContinueToAddQuestions'),
      click: 'continueToAddQuestions',
      icon: 'fas fa-angle-right',
    });
    this.updateToolBar(buttons);
  }
  public addQuestionsButtons(): void {
    const buttons: any = [];
    buttons.push({
      id: '1',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnBackToSection'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('inspectionForms.btnBackToSection'),
      click: 'backToSection',
      icon: 'fas fa-angle-left',
    });
    buttons.push({
      id: '2',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnContinueToReview'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('inspectionForms.btnContinueToReview'),
      click: 'continueToReview',
      icon: 'fas fa-angle-right',
    });
    this.updateToolBar(buttons);
  }
  public addReviewSectionAndQuestionsButtons(): void {
    const buttons: any = [];
    buttons.push({
      id: '1',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnBackToInspectionForm'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('inspectionForms.btnBackToInspectionForm'),
      click: 'backToInspectionForm',
      icon: 'fas fa-angle-left',
    });
    buttons.push({
      id: '2',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnBackToSection'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('inspectionForms.btnBackToSection'),
      click: 'backToSection',
      icon: 'fas fa-angle-left',
    });
    buttons.push({
      id: '3',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnBackToQuestion'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('inspectionForms.btnBackToQuestion'),
      click: 'backToQuestions',
      icon: 'fas fa-angle-left',
    });
    buttons.push({
      id: '4',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnContinueToSubmit'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('inspectionForms.btnContinueToSubmit'),
      click: 'continueToSubmit',
      icon: 'fas fa-check',
    });
    buttons.push({
      id: '5',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnPreviewInspectionPdf'),
      disabled: false,
      visible: true,
      class: 'btn success',
      label: this.$parent.$t('inspectionForms.btnPreviewInspectionPdf'),
      click: 'previewInspectionPDF',
      icon: 'fas fa-download',
      color: 'success',
      requestProgress: true,
    });
    this.updateToolBar(buttons);
  }
  public addSubmitInspectionFormButtons(): void {
    const buttons: any = [];
    buttons.push({
      id: '2',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnBackToReview'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('inspectionForms.btnBackToReview'),
      click: 'backToReview',
      icon: 'fas fa-angle-left',
    });
    this.updateToolBar(buttons);
  }
  public updateToolBar(additionalButtons): void {
    let buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('inspectionForms.btnBackToList'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('inspectionForms.btnBackToList'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });

    if (additionalButtons) {
      buttons = buttons.concat(additionalButtons);
    }
    this.$emit('updateToolBar', buttons);
  }
  public async mounted(): Promise<void> {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'inspectionForms');
    
    this.storeId = Number(this.$route.params.storeId)
      ? Number(this.$route.params.storeId)
      : Number(this.userSession.storeId);
    this.type = this.$route.params.type;
    this.inspectionForm.type = this.type;

    // Toolbar
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (this.$route.params.id) {
      try {
        this.isButtonLoading = true;
        this.formlyShowSkeleton(this.inspectionFormFields);
        const response = await inspectionFormService.getInspectionFormById(
          Number(this.$route.params.id)
        );
        this.inspectionForm = response;
        this.inspectionForm.type =
          this.inspectionForm.type === 'New' ? '0' : '1';
        this.stepperIndex = 4;
      } finally {
        this.formlyHideSkeleton(this.inspectionFormFields);
        this.isButtonLoading = false;
        this.addReviewSectionAndQuestionsButtons();
      }
    } else {
      this.inspectionFormDetailsButtons();
    }
  }

  public addSectionToInspectionForm() {
    const section = this.inspectionSection;
    const index = this.inspectionForm.sectionJson.findIndex(
      (x) => x.name === section.name
    );
    if (index !== -1) {
      this.showAlert(
        false,
        this.$parent.$t('inspectionForms.alertDuplicateSectionNameNotAllowed')
      );
      return;
    }

    const inspSec: InspectionFormSection = {
      name: this.inspectionSection.name,
      columnPosition: this.inspectionSection.columnPosition,
      questions: [],
    };
    this.inspectionForm.sectionJson.push(inspSec);

    this.inspectionSection.name = '';
    this.inspectionSection.questions = [];
  }

  public confirmDeleteSection(section): void {
    this.deleteDialog.model = true;
    this.sectionNameToDelete = section.name;
  }

  public deleteSection() {
    const index = this.inspectionForm.sectionJson.findIndex(
      (x) => x.name === this.sectionNameToDelete
    );
    if (index !== -1) {
      this.inspectionForm.sectionJson.splice(index, 1);
    }

    this.deleteDialog.model = false;
  }

  public editSection(section) {
    this.isSectionEditMode = true;
    this.editSectionIndex = this.inspectionForm.sectionJson.findIndex(
      (x) => x.name === section.name
    );
    if (this.editSectionIndex !== -1) {
      this.inspectionSection = Object.assign(
        {},
        this.inspectionForm.sectionJson[this.editSectionIndex]
      );
    }
  }

  public cancelEditSection() {
    this.editSectionIndex = -1;
    this.inspectionSection.name = '';
    this.inspectionSection.questions = [];
    this.isSectionEditMode = false;
  }

  public updateSectionToInspectionForm(section) {
    const inspSec: InspectionFormSection = {
      name: this.inspectionSection.name,
      columnPosition: this.inspectionSection.columnPosition,
      questions: [],
    };

    this.inspectionForm.sectionJson[this.editSectionIndex].name = inspSec.name;
    this.inspectionForm.sectionJson[this.editSectionIndex].columnPosition =
      inspSec.columnPosition;

    this.inspectionSection.name = '';
    this.inspectionSection.questions = [];
    this.editSectionIndex = -1;
    this.isSectionEditMode = false;
  }

  public addQuestionToSection() {
    const index = this.inspectionForm.sectionJson.findIndex(
      (x) => x.name === this.inspectionQuestion.sectionName
    );
    if (index === -1) {
      return;
    }

    // CHECK IF SAME QUESTION EXISTS IN SECTION ALREADY
    const questionIndex = this.inspectionForm.sectionJson[
      index
    ].questions.findIndex((x) => x.text === this.inspectionQuestion.text);
    if (questionIndex !== -1) {
      this.showAlert(
        false,
        this.$parent.$t('inspectionForms.alertDuplicateQuestionNotAllowed')
      );
      return;
    }

    this.inspectionForm.sectionJson[index].questions.push({
      text: this.inspectionQuestion.text,
    });

    this.inspectionQuestion.text = '';
    this.$validator.reset();
  }

  public confirmDeleteQuestionFromSection(item): void {
    this.deleteQuestionDialog.model = true;
    this.questionToDelete = item.text;
  }

  public deletedQuestionFromSection() {
    const index = this.inspectionForm.sectionJson.findIndex(
      (x) => x.name === this.inspectionQuestion.sectionName
    );

    if (index === -1) {
      return;
    }

    // CHECK IF SAME QUESTION EXISTS IN SECTION ALREADY
    const questionIndex = this.inspectionForm.sectionJson[
      index
    ].questions.findIndex((x) => x.text === this.questionToDelete);

    if (questionIndex === -1) {
      return;
    }

    this.inspectionForm.sectionJson[index].questions.splice(questionIndex, 1);

    this.questionToDelete = '';
    this.deleteQuestionDialog.model = false;
  }
  public switchToQuestionTab() {
    this.stepperIndex = 3;
    if (this.inspectionQuestion.sectionName === '') {
      this.inspectionQuestion.sectionName =
        this.inspectionForm.sectionJson.length > 0
          ? this.inspectionForm.sectionJson[0].name
          : '';
    }
    this.sectionSwitched(this.inspectionQuestion.sectionName);
  }

  public sectionSwitched(sectionName: string): void {
    const index = this.inspectionForm.sectionJson.findIndex(
      (x) => x.name === sectionName
    );
    if (index === -1) {
      this.inspectionSection.questions = [];
      return;
    }

    // CHECK IF SAME QUESTION EXISTS IN SECTION ALREADY
    this.inspectionSection.questions = this.inspectionForm.sectionJson[
      index
    ].questions;
  }

  public async submitInspectionForm(): Promise<void> {
    try {
      this.isButtonLoading = true;
      this.disableSubmitButton = true;
      this.$emit('update:progress', this.isButtonLoading);

      if (this.inspectionForm.id) {
        await inspectionFormService.updateForm(
          Number(this.inspectionForm.id),
          this.inspectionForm
        );
        this.$router.push({
          name: 'admin.inspection.forms.list',
          params: {
            storeId: this.storeId.toString(),
            type: this.type.toString(),
          },
        });
        this.showAlert(
          true,
          this.$t('inspectionForms.alertUpdateInspectionForm')
        );
      } else {
        this.inspectionForm.storeId = this.storeId;
        await inspectionFormService.create(this.inspectionForm);
        this.$router.push({
          name: 'admin.inspection.forms.list',
          params: {
            storeId: this.storeId.toString(),
            type: this.type.toString(),
          },
        });
        this.showAlert(
          true,
          this.$t('inspectionForms.alertSaveInspectionForm')
        );
      }
    } finally {
      this.isButtonLoading = false;
      this.disableSubmitButton = false;
      this.$emit('update:progress', this.isButtonLoading);
    }
  }

  public async downloadInspectionPreview(): Promise<void> {
    try {
      this.isButtonLoading = true;
      this.$emit('update:progress', this.isButtonLoading);
      this.inspectionForm.storeId = this.storeId;
      const response = await inspectionFormService.downloadPreview(
        this.inspectionForm
      );
      const bytes = FileHelper.base64ToArrayBuffer(response.fileBase64);
      FileHelper.downloadBytes(bytes, '', response.fileDownloadName);
    } finally {
      this.isButtonLoading = false;
      this.$emit('update:progress', this.isButtonLoading);
    }
  }
}
